import React from 'react';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CreateIcon from '@mui/icons-material/Create';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import ListIcon from '@mui/icons-material/List';
import DoneIcon from '@mui/icons-material/Done';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import 'font-awesome/css/font-awesome.min.css';
import VolumeOffIcon from  '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

import { palette } from '../../../palette';

const customButtonSx = (selected) => ({
    border: '1px solid #ced4da',
    backgroundColor: palette.primary.light,
    color: palette.primary.main,
    minWidth: '40px',
    width: '40px',
    height: '100%',
    '&:hover': {
        backgroundColor: palette.primary.main,
        color: palette.primary.light,
    },
    '&.MuiButton-textSecondary': {
        backgroundColor: palette.error.light,
        color: palette.error.dark,
        '&:hover': {
            backgroundColor: palette.error.main,
            color: palette.error.light,
        },
    },
    '&.MuiButton-outlinedPrimary': {
        backgroundColor: 'transparent',
        color: selected ? 'white' : palette.primary.muted,
        '&:hover': {
            backgroundColor: selected ? 'white' : 'transparent',
            color: palette.primary.main,
        },
    },
});

const CustomButton = ({ selected, sx, ...rest }) => (
    <Button {...rest} sx={{ ...customButtonSx(selected), ...sx }} />
);

  
function CustomIconButton(props) {

    function renderIcon(){
        
        if (props.icon === "VisibilityOffIcon") {
            return (
                <VisibilityOffIcon/>
            );
        }
        if (props.icon === "CreateIcon") {
            return (
                <CreateIcon/>
            );
        }
        if (props.icon === "CloseSharpIcon") {
            return (
                <CloseSharpIcon/>
            );
        }
        if (props.icon === "AddOutlinedIcon") {
            return (
                <AddOutlinedIcon/>
            );
        }
        if (props.icon === "ListIcon") {
            return (
                <ListIcon/>
            );
        }
        if (props.icon === "DoneIcon") {
            return (
                <DoneIcon/>
            );
        }
        if (props.icon === "AddPersonIcon") {
            return (
                <PersonAddIcon/>
            );
        }
        if (props.icon === "removePersonIcon") {
            return (
                <PersonRemoveIcon/>
            );
        }
        if (props.icon === "saveIcon") {
            return (
                <SaveIcon/>
            );
        }
        if (props.icon === "ClearIcon") {
            return (
                <i class="fa fa-eraser" aria-hidden="true" width="30"></i>
            );
        }
        if (props.icon === "volumeOffIcon") {
            return (
                <VolumeOffIcon/>
            );
        }
        if (props.icon === "volumeUpIcon") {
            return (
                <VolumeUpIcon/>
            );
        }

    }

    if(props.tooltip) {
        return (
            <Tooltip title={props.tooltip} placement="top" arrow>
                <CustomButton onClick={props.onClick} color={props.color} {...props}>
                    {renderIcon()}
                </CustomButton>
            </Tooltip>
        );
    } else{
        return (
                <CustomButton onClick={props.onClick} color={props.color} {...props}>
                    {renderIcon()}
                </CustomButton>
        );
    }
    
}

export default CustomIconButton;